import script from "./remoteTable.vue?vue&type=script&setup=true&lang=js"
export * from "./remoteTable.vue?vue&type=script&setup=true&lang=js"

import "./remoteTable.vue?vue&type=style&index=0&id=68318f4d&lang=scss&scoped=true"
import "./remoteTable.vue?vue&type=style&index=1&id=68318f4d&lang=css"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68318f4d"]])

export default __exports__